import { Component, computed, inject, input, InputSignal, Signal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { AmlScanEntity, LatestAmlReport, ReportProcess } from "../../../../../api/api.model";
import { TransactionOutcomingComponent } from "./components/transaction-outcoming/transaction-outcoming.component";
import { TransactionIncomingComponent } from "./components/transaction-incoming/transaction-incoming.component";
import { TransactionScanComponent } from "./components/transaction-scan/transaction-scan.component";
import { WalletScanComponent } from "./components/wallet-scan/wallet-scan.component";
import { ClusterIncomingReportComponent } from "./components/cluster-incoming-report/cluster-incoming-report.component";
import { LeaCaseComponent } from "./components/lea-case/lea-case.component";
import { AuthService } from "../../../../services/auth.service";
import { NgTemplateOutlet } from "@angular/common";
import { LeaShortReportComponent } from "./components/lea-short-report/lea-short-report.component";


@Component({
  selector: 'app-transaction-report',
  standalone: true,
  imports: [
    MatIconModule,
    TransactionOutcomingComponent,
    TransactionIncomingComponent,
    TransactionScanComponent,
    WalletScanComponent,
    LeaCaseComponent,
    LeaShortReportComponent,
    NgTemplateOutlet
  ],
  templateUrl: './transaction-report.component.html',
  styleUrl: './transaction-report.component.scss',
  host: {
    class: 'flex flex-col',
  }
})
export default class TransactionReportComponent {
  public readonly transaction: InputSignal<AmlScanEntity<LatestAmlReport>> = input.required();
  public readonly process: InputSignal<ReportProcess> = input.required();
  
  readonly authService: AuthService = inject(AuthService);
  
  readonly userRole: Signal<string> = computed(() => {
    const account = this.authService.accountDto();
    if (account) {
      return account.role;
    } else {
      return '';
    }
  });
}
